import { useDatastore } from "util/datastore";
import { colorTextPrimary } from 'component/color';
import { UtilityText } from 'component/text';

export type ModDashboardDateTimeProps = {
    timestamp: number;
    color?: string;
    type?: string;
};

function getEffectiveTimeZone() {
    if (process.env.NODE_ENV === 'test') {
        return 'America/New_York'; // Test timezone
    }
    return undefined; // Default to local timezone
}

export function ModDashboardDateTime({
    timestamp,
    color = colorTextPrimary,
    type = "small"
}: ModDashboardDateTimeProps) {
    const date = new Date(timestamp);
    const datastore = useDatastore()
    const language = datastore.getLanguage() || "english"
    const timeZone = getEffectiveTimeZone();

    let clientLocale = "";
    switch (language) {
    case "english":
        clientLocale = "en-US";
        break;
    case "german":
        clientLocale = "de-DE";
        break;
    case "french":
    case "french_belgian":
    case "french_canadian":
        clientLocale = "fr-CA";
        break;
    default:
        clientLocale = "en-US";
        break;
    }
    
    const dateOptions = { day: "2-digit", month: "short", year: "numeric", timeZone } as const;
    const timeOptions = { hour: "numeric", minute: "2-digit", timeZone } as const;

    const formattedDate = date.toLocaleDateString(clientLocale, dateOptions);
    let formattedTime = date.toLocaleTimeString(clientLocale, timeOptions).toLowerCase();

    if (clientLocale === "de-DE") {
        formattedTime += " Uhr";
    } else if (language === "fr-CA") {
        formattedTime = formattedTime.replace(":", "\u00A0h\u00A0");
    } else {
        formattedTime = formattedTime.replace(" ", "");
    }

    const formattedDateTime = `${formattedDate} | ${formattedTime}`;
    return <UtilityText text={formattedDateTime} color={color} type={type} />;
}